module.exports = __webpack_public_path__ + "static/img/akum_160.74d5490.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akum_160.svg
// module id = hz/9
// module chunks = 1